//@flow
import Model from '../../Utils/Model/model';

import type { MembershipObject } from '../Membership/membershipModel';

const activeMembershipStatuses = ['ACTIVE', 'DECLINED'];

export type CustomerObject = {
  id:string,
  email:string,
  firstname:string,
  lastname:string,
  has_membership_orders:boolean,
  has_membership:boolean,
  has_mem_subscription:boolean,
  is_guest:boolean,
  is_fb_user:boolean,
  store_credit:number,
  store_credit_expiring:number,
  store_credit_exp_date:?string,
  customer_group?:string,
  created_at:string,
  updated_at:string,
  membership:?$Shape<MembershipObject>,
};

export default class CustomerModel extends Model<CustomerObject> {
  getId():string {
    return this.attributes.id;
  }

  getEmail():string {
    return this.attributes.email;
  }

  getFirstname():string {
    return this.attributes.firstname;
  }

  getLastname():string {
    return this.attributes.lastname;
  }

  getStoreCredit():number {
    return this.attributes.store_credit;
  }

  getStoreCreditExpiring():number {
    return this.attributes.store_credit_expiring || 0;
  }

  getStoreCreditExpDate():string {
    return this.attributes.store_credit_exp_date || '';
  }

  getCreationDate():string {
    return this.attributes.created_at;
  }

  getCustomerGroup():?string {
    return this.attributes.customer_group;
  }

  /*
   * Returns formatted store credit.
   * @return {string} if credit is 0 or undefined, return "0"
   */
  getStoreCreditFormatted():string {
    const credit = this.getStoreCredit();
    if (credit) {
      return credit.toFixed(2);
    }

    return '0';
  }

  _getMembership():$Shape<MembershipObject> {
    return this.attributes.membership || {};
  }

  getMembershipStatus():?string {
    return this._getMembership().status;
  }

  hasMembershipOrders():boolean {
    return !!this.attributes.has_membership_orders;
  }

  hasMembership():boolean {
    return !!this.attributes.has_membership;
  }

  hasMemSubscription():boolean {
    return !!this.attributes.has_mem_subscription;
  }

  hasActiveMembership() {
    const status = this.getMembershipStatus();
    return activeMembershipStatuses.indexOf(status) !== -1;
  }

  isGuest() {
    return !!this.attributes.is_guest;
  }

  isFBUser():boolean {
    return !!this.attributes.is_fb_user;
  }

  isMsrp():boolean {
    return this.getCustomerGroup() === 'MSRP';
  }
}
